/*=========================================================================================
  File Name: modulePersonnel.js
  Description: Calendar Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './modulePersonnelState.js'
import mutations from './modulePersonnelMutations.js'
import actions from './modulePersonnelActions.js'
import getters from './modulePersonnelGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

